<div class="tip-cont">
   <i class="pi pi-info-circle ml-2 tool-tip" tooltipPosition="{{tipLocation}}" *ngIf="toolTipPath" pTooltip="{{toolTipPath | translate}}" ></i>
</div>
<p-chart class="chart-container" #chart [type]="chartType" [data]="data"
[options]="options"
[height]="height" [responsive]="true"></p-chart>
